export const jokerMap = {
  j_joker: {
    properName: "Joker",
    imagePath: "jokers/j_joker.png",
    wiki: "https://balatrogame.fandom.com/wiki/Joker_(Joker)",
  },
  j_greedy_joker: {
    properName: "Greedy Joker",
    imagePath: "jokers/j_greedy_joker.png",
    wiki: "https://balatrogame.fandom.com/wiki/Greedy_Joker_(Joker)",
  },
  j_lusty_joker: {
    properName: "Lusty Joker",
    imagePath: "jokers/j_lusty_joker.png",
    wiki: "https://balatrogame.fandom.com/wiki/Lusty_Joker_(Joker)",
  },
  j_wrathful_joker: {
    properName: "Wrathful Joker",
    imagePath: "jokers/j_wrathful_joker.png",
    wiki: "https://balatrogame.fandom.com/wiki/Wrathful_Joker_(Joker)",
  },
  j_gluttenous_joker: {
    properName: "Gluttonous Joker",
    imagePath: "jokers/j_gluttenous_joker.png",
    wiki: "https://balatrogame.fandom.com/wiki/Gluttonous_Joker_(Joker)",
  },
  j_jolly: {
    properName: "Jolly Joker",
    imagePath: "jokers/j_jolly.png",
    wiki: "https://balatrogame.fandom.com/wiki/Jolly_Joker_(Joker)",
  },
  j_zany: {
    properName: "Zany Joker",
    imagePath: "jokers/j_zany.png",
    wiki: "https://balatrogame.fandom.com/wiki/Zany_Joker_(Joker)",
  },
  j_mad: {
    properName: "Mad Joker",
    imagePath: "jokers/j_mad.png",
    wiki: "https://balatrogame.fandom.com/wiki/Mad_Joker_(Joker)",
  },
  j_crazy: {
    properName: "Crazy Joker",
    imagePath: "jokers/j_crazy.png",
    wiki: "https://balatrogame.fandom.com/wiki/Crazy_Joker_(Joker)",
  },
  j_droll: {
    properName: "Droll Joker",
    imagePath: "jokers/j_droll.png",
    wiki: "https://balatrogame.fandom.com/wiki/Droll_Joker_(Joker)",
  },
  j_sly: {
    properName: "Sly Joker",
    imagePath: "jokers/j_sly.png",
    wiki: "https://balatrogame.fandom.com/wiki/Sly_Joker_(Joker)",
  },
  j_wily: {
    properName: "Wily Joker",
    imagePath: "jokers/j_wily.png",
    wiki: "https://balatrogame.fandom.com/wiki/Wily_Joker_(Joker)",
  },
  j_clever: {
    properName: "Clever Joker",
    imagePath: "jokers/j_clever.png",
    wiki: "https://balatrogame.fandom.com/wiki/Clever_Joker_(Joker)",
  },
  j_devious: {
    properName: "Devious Joker",
    imagePath: "jokers/j_devious.png",
    wiki: "https://balatrogame.fandom.com/wiki/Devious_Joker_(Joker)",
  },
  j_crafty: {
    properName: "Crafty Joker",
    imagePath: "jokers/j_crafty.png",
    wiki: "https://balatrogame.fandom.com/wiki/Crafty_Joker_(Joker)",
  },
  j_half: {
    properName: "Half Joker",
    imagePath: "jokers/j_half.png",
    wiki: "https://balatrogame.fandom.com/wiki/Half_Joker_(Joker)",
  },
  j_stencil: {
    properName: "Joker Stencil",
    imagePath: "jokers/j_stencil.png",
    wiki: "https://balatrogame.fandom.com/wiki/Joker_Stencil_(Joker)",
  },
  j_four_fingers: {
    properName: "Four Fingers",
    imagePath: "jokers/j_four_fingers.png",
    wiki: "https://balatrogame.fandom.com/wiki/Four_Fingers_(Joker)",
  },
  j_mime: {
    properName: "Mime",
    imagePath: "jokers/j_mime.png",
    wiki: "https://balatrogame.fandom.com/wiki/Mime_(Joker)",
  },
  j_credit_card: {
    properName: "Credit Card",
    imagePath: "jokers/j_credit_card.png",
    wiki: "https://balatrogame.fandom.com/wiki/Credit_Card_(Joker)",
  },
  j_ceremonial: {
    properName: "Ceremonial Dagger",
    imagePath: "jokers/j_ceremonial.png",
    wiki: "https://balatrogame.fandom.com/wiki/Ceremonial_Dagger_(Joker)",
  },
  j_banner: {
    properName: "Banner",
    imagePath: "jokers/j_banner.png",
    wiki: "https://balatrogame.fandom.com/wiki/Banner_(Joker)",
  },
  j_mystic_summit: {
    properName: "Mystic Summit",
    imagePath: "jokers/j_mystic_summit.png",
    wiki: "https://balatrogame.fandom.com/wiki/Mystic_Summit_(Joker)",
  },
  j_marble: {
    properName: "Marble Joker",
    imagePath: "jokers/j_marble.png",
    wiki: "https://balatrogame.fandom.com/wiki/Marble_Joker_(Joker)",
  },
  j_loyalty_card: {
    properName: "Loyalty Card",
    imagePath: "jokers/j_loyalty_card.png",
    wiki: "https://balatrogame.fandom.com/wiki/Loyalty_Card_(Joker)",
  },
  j_8_ball: {
    properName: "8 Ball",
    imagePath: "jokers/j_8_ball.png",
    wiki: "https://balatrogame.fandom.com/wiki/8_Ball_(Joker)",
  },
  j_misprint: {
    properName: "Misprint",
    imagePath: "jokers/j_misprint.png",
    wiki: "https://balatrogame.fandom.com/wiki/Misprint_(Joker)",
  },
  j_dusk: {
    properName: "Dusk",
    imagePath: "jokers/j_dusk.png",
    wiki: "https://balatrogame.fandom.com/wiki/Dusk_(Joker)",
  },
  j_raised_fist: {
    properName: "Raised Fist",
    imagePath: "jokers/j_raised_fist.png",
    wiki: "https://balatrogame.fandom.com/wiki/Raised_Fist_(Joker)",
  },
  j_chaos: {
    properName: "Chaos the Clown",
    imagePath: "jokers/j_chaos.png",
    wiki: "https://balatrogame.fandom.com/wiki/Chaos_the_Clown_(Joker)",
  },
  j_fibonacci: {
    properName: "Fibonacci",
    imagePath: "jokers/j_fibonacci.png",
    wiki: "https://balatrogame.fandom.com/wiki/Fibonacci_(Joker)",
  },
  j_steel_joker: {
    properName: "Steel Joker",
    imagePath: "jokers/j_steel_joker.png",
    wiki: "https://balatrogame.fandom.com/wiki/Steel_Joker_(Joker)",
  },
  j_scary_face: {
    properName: "Scary Face",
    imagePath: "jokers/j_scary_face.png",
    wiki: "https://balatrogame.fandom.com/wiki/Scary_Face_(Joker)",
  },
  j_abstract: {
    properName: "Abstract Joker",
    imagePath: "jokers/j_abstract.png",
    wiki: "https://balatrogame.fandom.com/wiki/Abstract_Joker_(Joker)",
  },
  j_delayed_grat: {
    properName: "Delayed Gratification",
    imagePath: "jokers/j_delayed_grat.png",
    wiki: "https://balatrogame.fandom.com/wiki/Delayed_Gratification_(Joker)",
  },
  j_hack: {
    properName: "Hack",
    imagePath: "jokers/j_hack.png",
    wiki: "https://balatrogame.fandom.com/wiki/Hack_(Joker)",
  },
  j_pareidolia: {
    properName: "Pareidolia",
    imagePath: "jokers/j_pareidolia.png",
    wiki: "https://balatrogame.fandom.com/wiki/Pareidolia_(Joker)",
  },
  j_gros_michel: {
    properName: "Gros Michel",
    imagePath: "jokers/j_gros_michel.png",
    wiki: "https://balatrogame.fandom.com/wiki/Gros_Michel_(Joker)",
  },
  j_even_steven: {
    properName: "Even Steven",
    imagePath: "jokers/j_even_steven.png",
    wiki: "https://balatrogame.fandom.com/wiki/Even_Steven_(Joker)",
  },
  j_odd_todd: {
    properName: "Odd Todd",
    imagePath: "jokers/j_odd_todd.png",
    wiki: "https://balatrogame.fandom.com/wiki/Odd_Todd_(Joker)",
  },
  j_scholar: {
    properName: "Scholar",
    imagePath: "jokers/j_scholar.png",
    wiki: "https://balatrogame.fandom.com/wiki/Scholar_(Joker)",
  },
  j_business: {
    properName: "Business Card",
    imagePath: "jokers/j_business.png",
    wiki: "https://balatrogame.fandom.com/wiki/Business_Card_(Joker)",
  },
  j_supernova: {
    properName: "Supernova",
    imagePath: "jokers/j_supernova.png",
    wiki: "https://balatrogame.fandom.com/wiki/Supernova_(Joker)",
  },
  j_ride_the_bus: {
    properName: "Ride the Bus",
    imagePath: "jokers/j_ride_the_bus.png",
    wiki: "https://balatrogame.fandom.com/wiki/Ride_the_Bus_(Joker)",
  },
  j_space: {
    properName: "Space Joker",
    imagePath: "jokers/j_space.png",
    wiki: "https://balatrogame.fandom.com/wiki/Space_Joker_(Joker)",
  },
  j_egg: {
    properName: "Egg",
    imagePath: "jokers/j_egg.png",
    wiki: "https://balatrogame.fandom.com/wiki/Egg_(Joker)",
  },
  j_burglar: {
    properName: "Burglar",
    imagePath: "jokers/j_burglar.png",
    wiki: "https://balatrogame.fandom.com/wiki/Burglar_(Joker)",
  },
  j_blackboard: {
    properName: "Blackboard",
    imagePath: "jokers/j_blackboard.png",
    wiki: "https://balatrogame.fandom.com/wiki/Blackboard_(Joker)",
  },
  j_runner: {
    properName: "Runner",
    imagePath: "jokers/j_runner.png",
    wiki: "https://balatrogame.fandom.com/wiki/Runner_(Joker)",
  },
  j_ice_cream: {
    properName: "Ice Cream",
    imagePath: "jokers/j_ice_cream.png",
    wiki: "https://balatrogame.fandom.com/wiki/Ice_Cream_(Joker)",
  },
  j_dna: {
    properName: "DNA",
    imagePath: "jokers/j_dna.png",
    wiki: "https://balatrogame.fandom.com/wiki/DNA_(Joker)",
  },
  j_splash: {
    properName: "Splash",
    imagePath: "jokers/j_splash.png",
    wiki: "https://balatrogame.fandom.com/wiki/Splash_(Joker)",
  },
  j_blue_joker: {
    properName: "Blue Joker",
    imagePath: "jokers/j_blue_joker.png",
    wiki: "https://balatrogame.fandom.com/wiki/Blue_Joker_(Joker)",
  },
  j_sixth_sense: {
    properName: "Sixth Sense",
    imagePath: "jokers/j_sixth_sense.png",
    wiki: "https://balatrogame.fandom.com/wiki/Sixth_Sense_(Joker)",
  },
  j_constellation: {
    properName: "Constellation",
    imagePath: "jokers/j_constellation.png",
    wiki: "https://balatrogame.fandom.com/wiki/Constellation_(Joker)",
  },
  j_hiker: {
    properName: "Hiker",
    imagePath: "jokers/j_hiker.png",
    wiki: "https://balatrogame.fandom.com/wiki/Hiker_(Joker)",
  },
  j_faceless: {
    properName: "Faceless Joker",
    imagePath: "jokers/j_faceless.png",
    wiki: "https://balatrogame.fandom.com/wiki/Faceless_Joker_(Joker)",
  },
  j_green_joker: {
    properName: "Green Joker",
    imagePath: "jokers/j_green_joker.png",
    wiki: "https://balatrogame.fandom.com/wiki/Green_Joker_(Joker)",
  },
  j_superposition: {
    properName: "Superposition",
    imagePath: "jokers/j_superposition.png",
    wiki: "https://balatrogame.fandom.com/wiki/Superposition_(Joker)",
  },
  j_todo_list: {
    properName: "To Do List",
    imagePath: "jokers/j_todo_list.png",
    wiki: "https://balatrogame.fandom.com/wiki/To_Do_List_(Joker)",
  },
  j_cavendish: {
    properName: "Cavendish",
    imagePath: "jokers/j_cavendish.png",
    wiki: "https://balatrogame.fandom.com/wiki/Cavendish_(Joker)",
  },
  j_card_sharp: {
    properName: "Card Sharp",
    imagePath: "jokers/j_card_sharp.png",
    wiki: "https://balatrogame.fandom.com/wiki/Card_Sharp_(Joker)",
  },
  j_red_card: {
    properName: "Red Card",
    imagePath: "jokers/j_red_card.png",
    wiki: "https://balatrogame.fandom.com/wiki/Red_Card_(Joker)",
  },
  j_madness: {
    properName: "Madness",
    imagePath: "jokers/j_madness.png",
    wiki: "https://balatrogame.fandom.com/wiki/Madness_(Joker)",
  },
  j_square: {
    properName: "Square Joker",
    imagePath: "jokers/j_square.png",
    wiki: "https://balatrogame.fandom.com/wiki/Square_Joker_(Joker)",
  },
  j_seance: {
    properName: "Séance",
    imagePath: "jokers/j_seance.png",
    wiki: "https://balatrogame.fandom.com/wiki/Séance_(Joker)",
  },
  j_riff_raff: {
    properName: "Riff-raff",
    imagePath: "jokers/j_riff_raff.png",
    wiki: "https://balatrogame.fandom.com/wiki/Riff-raff_(Joker)",
  },
  j_vampire: {
    properName: "Vampire",
    imagePath: "jokers/j_vampire.png",
    wiki: "https://balatrogame.fandom.com/wiki/Vampire_(Joker)",
  },
  j_shortcut: {
    properName: "Shortcut",
    imagePath: "jokers/j_shortcut.png",
    wiki: "https://balatrogame.fandom.com/wiki/Shortcut_(Joker)",
  },
  j_hologram: {
    properName: "Hologram",
    imagePath: "jokers/j_hologram.gif",
    wiki: "https://balatrogame.fandom.com/wiki/Hologram_(Joker)",
  },
  j_vagabond: {
    properName: "Vagabond",
    imagePath: "jokers/j_vagabond.png",
    wiki: "https://balatrogame.fandom.com/wiki/Vagabond_(Joker)",
  },
  j_baron: {
    properName: "Baron",
    imagePath: "jokers/j_baron.png",
    wiki: "https://balatrogame.fandom.com/wiki/Baron_(Joker)",
  },
  j_cloud_9: {
    properName: "Cloud 9",
    imagePath: "jokers/j_cloud_9.png",
    wiki: "https://balatrogame.fandom.com/wiki/Cloud_9_(Joker)",
  },
  j_rocket: {
    properName: "Rocket",
    imagePath: "jokers/j_rocket.png",
    wiki: "https://balatrogame.fandom.com/wiki/Rocket_(Joker)",
  },
  j_obelisk: {
    properName: "Obelisk",
    imagePath: "jokers/j_obelisk.png",
    wiki: "https://balatrogame.fandom.com/wiki/Obelisk_(Joker)",
  },
  j_midas_mask: {
    properName: "Midas Mask",
    imagePath: "jokers/j_midas_mask.png",
    wiki: "https://balatrogame.fandom.com/wiki/Midas_Mask_(Joker)",
  },
  j_luchador: {
    properName: "Luchador",
    imagePath: "jokers/j_luchador.png",
    wiki: "https://balatrogame.fandom.com/wiki/Luchador_(Joker)",
  },
  j_photograph: {
    properName: "Photograph",
    imagePath: "jokers/j_photograph.png",
    wiki: "https://balatrogame.fandom.com/wiki/Photograph_(Joker)",
  },
  j_gift: {
    properName: "Gift Card",
    imagePath: "jokers/j_gift.png",
    wiki: "https://balatrogame.fandom.com/wiki/Gift_Card_(Joker)",
  },
  j_turtle_bean: {
    properName: "Turtle Bean",
    imagePath: "jokers/j_turtle_bean.png",
    wiki: "https://balatrogame.fandom.com/wiki/Turtle_Bean_(Joker)",
  },
  j_erosion: {
    properName: "Erosion",
    imagePath: "jokers/j_erosion.png",
    wiki: "https://balatrogame.fandom.com/wiki/Erosion_(Joker)",
  },
  j_reserved_parking: {
    properName: "Reserved Parking",
    imagePath: "jokers/j_reserved_parking.png",
    wiki: "https://balatrogame.fandom.com/wiki/Reserved_Parking_(Joker)",
  },
  j_mail: {
    properName: "Mail-In Rebate",
    imagePath: "jokers/j_mail.png",
    wiki: "https://balatrogame.fandom.com/wiki/Mail-In_Rebate_(Joker)",
  },
  j_to_the_moon: {
    properName: "To the Moon",
    imagePath: "jokers/j_to_the_moon.png",
    wiki: "https://balatrogame.fandom.com/wiki/To_the_Moon_(Joker)",
  },
  j_hallucination: {
    properName: "Hallucination",
    imagePath: "jokers/j_hallucination.png",
    wiki: "https://balatrogame.fandom.com/wiki/Hallucination_(Joker)",
  },
  j_fortune_teller: {
    properName: "Fortune Teller",
    imagePath: "jokers/j_fortune_teller.png",
    wiki: "https://balatrogame.fandom.com/wiki/Fortune_Teller_(Joker)",
  },
  j_juggler: {
    properName: "Juggler",
    imagePath: "jokers/j_juggler.png",
    wiki: "https://balatrogame.fandom.com/wiki/Juggler_(Joker)",
  },
  j_drunkard: {
    properName: "Drunkard",
    imagePath: "jokers/j_drunkard.png",
    wiki: "https://balatrogame.fandom.com/wiki/Drunkard_(Joker)",
  },
  j_stone: {
    properName: "Stone Joker",
    imagePath: "jokers/j_stone.png",
    wiki: "https://balatrogame.fandom.com/wiki/Stone_Joker_(Joker)",
  },
  j_golden: {
    properName: "Golden Joker",
    imagePath: "jokers/j_golden.png",
    wiki: "https://balatrogame.fandom.com/wiki/Golden_Joker_(Joker)",
  },
  j_lucky_cat: {
    properName: "Lucky Cat",
    imagePath: "jokers/j_lucky_cat.png",
    wiki: "https://balatrogame.fandom.com/wiki/Lucky_Cat_(Joker)",
  },
  j_baseball: {
    properName: "Baseball Card",
    imagePath: "jokers/j_baseball.png",
    wiki: "https://balatrogame.fandom.com/wiki/Baseball_Card_(Joker)",
  },
  j_bull: {
    properName: "Bull",
    imagePath: "jokers/j_bull.png",
    wiki: "https://balatrogame.fandom.com/wiki/Bull_(Joker)",
  },
  j_diet_cola: {
    properName: "Diet Cola",
    imagePath: "jokers/j_diet_cola.png",
    wiki: "https://balatrogame.fandom.com/wiki/Diet_Cola_(Joker)",
  },
  j_trading: {
    properName: "Trading Card",
    imagePath: "jokers/j_trading.png",
    wiki: "https://balatrogame.fandom.com/wiki/Trading_Card_(Joker)",
  },
  j_flash: {
    properName: "Flash Card",
    imagePath: "jokers/j_flash.png",
    wiki: "https://balatrogame.fandom.com/wiki/Flash_Card_(Joker)",
  },
  j_popcorn: {
    properName: "Popcorn",
    imagePath: "jokers/j_popcorn.png",
    wiki: "https://balatrogame.fandom.com/wiki/Popcorn_(Joker)",
  },
  j_trousers: {
    properName: "Spare Trousers",
    imagePath: "jokers/j_trousers.png",
    wiki: "https://balatrogame.fandom.com/wiki/Spare_Trousers_(Joker)",
  },
  j_ancient: {
    properName: "Ancient Joker",
    imagePath: "jokers/j_ancient.png",
    wiki: "https://balatrogame.fandom.com/wiki/Ancient_Joker_(Joker)",
  },
  j_ramen: {
    properName: "Ramen",
    imagePath: "jokers/j_ramen.png",
    wiki: "https://balatrogame.fandom.com/wiki/Ramen_(Joker)",
  },
  j_walkie_talkie: {
    properName: "Walkie Talkie",
    imagePath: "jokers/j_walkie_talkie.png",
    wiki: "https://balatrogame.fandom.com/wiki/Walkie_Talkie_(Joker)",
  },
  j_selzer: {
    properName: "Seltzer",
    imagePath: "jokers/j_selzer.png",
    wiki: "https://balatrogame.fandom.com/wiki/Seltzer_(Joker)",
  },
  j_castle: {
    properName: "Castle",
    imagePath: "jokers/j_castle.png",
    wiki: "https://balatrogame.fandom.com/wiki/Castle_(Joker)",
  },
  j_smiley: {
    properName: "Smiley Face",
    imagePath: "jokers/j_smiley.png",
    wiki: "https://balatrogame.fandom.com/wiki/Smiley_Face_(Joker)",
  },
  j_campfire: {
    properName: "Campfire",
    imagePath: "jokers/j_campfire.png",
    wiki: "https://balatrogame.fandom.com/wiki/Campfire_(Joker)",
  },
  j_ticket: {
    properName: "Golden Ticket",
    imagePath: "jokers/j_ticket.png",
    wiki: "https://balatrogame.fandom.com/wiki/Golden_Ticket_(Joker)",
  },
  j_mr_bones: {
    properName: "Mr. Bones",
    imagePath: "jokers/j_mr._bones.png",
    wiki: "https://balatrogame.fandom.com/wiki/Mr._Bones_(Joker)",
  },
  j_acrobat: {
    properName: "Acrobat",
    imagePath: "jokers/j_acrobat.png",
    wiki: "https://balatrogame.fandom.com/wiki/Acrobat_(Joker)",
  },
  j_sock_and_buskin: {
    properName: "Sock and Buskin",
    imagePath: "jokers/j_sock_and_buskin.png",
    wiki: "https://balatrogame.fandom.com/wiki/Sock_and_Buskin_(Joker)",
  },
  j_swashbuckler: {
    properName: "Swashbuckler",
    imagePath: "jokers/j_swashbuckler.png",
    wiki: "https://balatrogame.fandom.com/wiki/Swashbuckler_(Joker)",
  },
  j_troubadour: {
    properName: "Troubadour",
    imagePath: "jokers/j_troubadour.png",
    wiki: "https://balatrogame.fandom.com/wiki/Troubadour_(Joker)",
  },
  j_certificate: {
    properName: "Certificate",
    imagePath: "jokers/j_certificate.png",
    wiki: "https://balatrogame.fandom.com/wiki/Certificate_(Joker)",
  },
  j_smeared: {
    properName: "Smeared Joker",
    imagePath: "jokers/j_smeared.png",
    wiki: "https://balatrogame.fandom.com/wiki/Smeared_Joker_(Joker)",
  },
  j_throwback: {
    properName: "Throwback",
    imagePath: "jokers/j_throwback.png",
    wiki: "https://balatrogame.fandom.com/wiki/Throwback_(Joker)",
  },
  j_hanging_chad: {
    properName: "Hanging Chad",
    imagePath: "jokers/j_hanging_chad.png",
    wiki: "https://balatrogame.fandom.com/wiki/Hanging_Chad_(Joker)",
  },
  j_rough_gem: {
    properName: "Rough Gem",
    imagePath: "jokers/j_rough_gem.png",
    wiki: "https://balatrogame.fandom.com/wiki/Rough_Gem_(Joker)",
  },
  j_bloodstone: {
    properName: "Bloodstone",
    imagePath: "jokers/j_bloodstone.png",
    wiki: "https://balatrogame.fandom.com/wiki/Bloodstone_(Joker)",
  },
  j_arrowhead: {
    properName: "Arrowhead",
    imagePath: "jokers/j_arrowhead.png",
    wiki: "https://balatrogame.fandom.com/wiki/Arrowhead_(Joker)",
  },
  j_onyx_agate: {
    properName: "Onyx Agate",
    imagePath: "jokers/j_onyx_agate.png",
    wiki: "https://balatrogame.fandom.com/wiki/Onyx_Agate_(Joker)",
  },
  j_glass: {
    properName: "Glass Joker",
    imagePath: "jokers/j_glass.png",
    wiki: "https://balatrogame.fandom.com/wiki/Glass_Joker_(Joker)",
  },
  j_ring_master: {
    properName: "Showman",
    imagePath: "jokers/j_ring_master.png",
    wiki: "https://balatrogame.fandom.com/wiki/Showman_(Joker)",
  },
  j_flower_pot: {
    properName: "Flower Pot",
    imagePath: "jokers/j_flower_pot.png",
    wiki: "https://balatrogame.fandom.com/wiki/Flower_Pot_(Joker)",
  },
  j_blueprint: {
    properName: " Blueprint",
    imagePath: "jokers/j_blueprint.png",
    wiki: "https://balatrogame.fandom.com/wiki/_Blueprint_(Joker)",
  },
  j_wee: {
    properName: "Wee Joker",
    imagePath: "jokers/j_wee.png",
    wiki: "https://balatrogame.fandom.com/wiki/Wee_Joker_(Joker)",
  },
  j_merry_andy: {
    properName: "Merry Andy",
    imagePath: "jokers/j_merry_andy.png",
    wiki: "https://balatrogame.fandom.com/wiki/Merry_Andy_(Joker)",
  },
  j_oops: {
    properName: "Oops! All 6s",
    imagePath: "jokers/j_oops.png",
    wiki: "https://balatrogame.fandom.com/wiki/Oops!_All_6s_(Joker)",
  },
  j_idol: {
    properName: "The Idol",
    imagePath: "jokers/j_idol.png",
    wiki: "https://balatrogame.fandom.com/wiki/The_Idol_(Joker)",
  },
  j_seeing_double: {
    properName: "Seeing Double",
    imagePath: "jokers/j_seeing_double.png",
    wiki: "https://balatrogame.fandom.com/wiki/Seeing_Double_(Joker)",
  },
  j_matador: {
    properName: "Matador",
    imagePath: "jokers/j_matador.png",
    wiki: "https://balatrogame.fandom.com/wiki/Matador_(Joker)",
  },
  j_hit_the_road: {
    properName: "Hit the Road",
    imagePath: "jokers/j_hit_the_road.png",
    wiki: "https://balatrogame.fandom.com/wiki/Hit_the_Road_(Joker)",
  },
  j_duo: {
    properName: "The Duo",
    imagePath: "jokers/j_duo.png",
    wiki: "https://balatrogame.fandom.com/wiki/The_Duo_(Joker)",
  },
  j_trio: {
    properName: "The Trio",
    imagePath: "jokers/j_trio.png",
    wiki: "https://balatrogame.fandom.com/wiki/The_Trio_(Joker)",
  },
  j_family: {
    properName: "The Family",
    imagePath: "jokers/j_family.png",
    wiki: "https://balatrogame.fandom.com/wiki/The_Family_(Joker)",
  },
  j_order: {
    properName: "The Order",
    imagePath: "jokers/j_order.png",
    wiki: "https://balatrogame.fandom.com/wiki/The_Order_(Joker)",
  },
  j_tribe: {
    properName: "The Tribe",
    imagePath: "jokers/j_tribe.png",
    wiki: "https://balatrogame.fandom.com/wiki/The_Tribe_(Joker)",
  },
  j_stuntman: {
    properName: "Stuntman",
    imagePath: "jokers/j_stuntman.png",
    wiki: "https://balatrogame.fandom.com/wiki/Stuntman_(Joker)",
  },
  j_invisible: {
    properName: "Invisible Joker",
    imagePath: "jokers/j_invisible.png",
    wiki: "https://balatrogame.fandom.com/wiki/Invisible_Joker_(Joker)",
  },
  j_brainstorm: {
    properName: "Brainstorm",
    imagePath: "jokers/j_brainstorm.png",
    wiki: "https://balatrogame.fandom.com/wiki/Brainstorm_(Joker)",
  },
  j_satellite: {
    properName: "Satellite",
    imagePath: "jokers/j_sattelite.png",
    wiki: "https://balatrogame.fandom.com/wiki/Satellite_(Joker)",
  },
  j_shoot_the_moon: {
    properName: "Shoot the Moon",
    imagePath: "jokers/j_shoot_the_moon.png",
    wiki: "https://balatrogame.fandom.com/wiki/Shoot_the_Moon_(Joker)",
  },
  j_drivers_license: {
    properName: "Driver's License",
    imagePath: "jokers/j_drivers_license.png",
    wiki: "https://balatrogame.fandom.com/wiki/Driver's_License_(Joker)",
  },
  "": {
    properName: "",
    imagePath: "jokers/.png",
    wiki: "",
  },
  j_astronomer: {
    properName: "Astronomer",
    imagePath: "jokers/j_astronomer.png",
    wiki: "https://balatrogame.fandom.com/wiki/Astronomer_(Joker)",
  },
  j_burnt: {
    properName: "Burnt Joker",
    imagePath: "jokers/j_burnt.png",
    wiki: "https://balatrogame.fandom.com/wiki/Burnt_Joker_(Joker)",
  },
  j_bootstraps: {
    properName: "Bootstraps",
    imagePath: "jokers/j_bootstraps.png",
    wiki: "https://balatrogame.fandom.com/wiki/Bootstraps_(Joker)",
  },
  j_caino: {
    properName: "Canio",
    imagePath: "jokers/j_caino.png",
    wiki: "https://balatrogame.fandom.com/wiki/Canio_(Joker)",
  },
  j_triboulet: {
    properName: "Triboulet",
    imagePath: "jokers/j_triboulet.png",
    wiki: "https://balatrogame.fandom.com/wiki/Triboulet_(Joker)",
  },
  j_yorick: {
    properName: "Yorick",
    imagePath: "jokers/j_yorick.png",
    wiki: "https://balatrogame.fandom.com/wiki/Yorick_(Joker)",
  },
  j_chicot: {
    properName: "Chicot",
    imagePath: "jokers/j_chicot.png",
    wiki: "https://balatrogame.fandom.com/wiki/Chicot_(Joker)",
  },
  j_perkeo: {
    properName: "Perkeo",
    imagePath: "jokers/j_perkeo.png",
    wiki: "https://balatrogame.fandom.com/wiki/Perkeo_(Joker)",
  },
  j_cartomancer: {
    properName: "Cartomancer",
    imagePath: "jokers/j_cartomancer",
    wiki: "https://balatrogame.fandom.com/wiki/Cartomancer_(Joker)"
  }
};
